import { useMemo } from "react";
import { useFetch } from "@/hooks/useFetch";
import { StatCard } from "@/components/StatCard";
import { brl } from "@/lib/format";
import { usePayrollSettings } from "@/context/PayrollSettingsContext";
import { computeAutoBonus } from "@/lib/bonusConfig";
import { useMinsFor } from "@/lib/useBaseMins";
import { useContractTypes } from "@/lib/useContractTypes";
import { useOutOfPayBase } from "@/lib/usePayBases";
import { Fuel, Utensils, Bus, Trophy } from "lucide-react";

const today = new Date();
const year = today.getFullYear();
const month = today.getMonth() + 1;
const quinzena = today.getDate() <= 15 ? 1 : 2;
const inQ = (dt) => { const d = Number(String(dt).slice(8, 10)); return quinzena === 1 ? d <= 15 : d >= 16; };

export const DashboardBenefits = () => {
  const report = useFetch("/admin/benefits-report", { year, month });
  const reports = useFetch("/admin/reports", { year, month, quinzena });
  const cfg = useFetch("/config");
  const tiersData = useFetch("/admin/bonus-tiers");
  const { settings } = usePayrollSettings();
  const minsFor = useMinsFor();
  const contractOf = useContractTypes();
  const outOfBase = useOutOfPayBase();

  const t = useMemo(() => {
    const mins = { ...(cfg.data || {}), mestre_min: cfg.data?.mestre_min ?? settings.mestre_min };
    const tiers = tiersData.data?.tiers || [];
    const a = { fuel: 0, meal: 0, commute: 0, prod: 0 };
    (report.data?.drivers || []).filter((d) => !outOfBase(d.id)).forEach((d) => (d.days || []).forEach((dy) => {
      if (!inQ(dy.date)) return;
      a.fuel += dy.fuel || 0; a.meal += dy.meal || 0; a.commute += dy.commute || 0;
    }));
    (reports.data?.rows || []).filter((r) => !outOfBase(r.id)).forEach((r) => { a.prod += computeAutoBonus(r.deliveries || 0, minsFor(r.id, mins), tiers, contractOf(r.id)).value; });
    return a;
  }, [report.data, reports.data, cfg.data, tiersData.data, settings.mestre_min, minsFor, contractOf, outOfBase]);

  const v = (x) => (report.loading || !contractOf.ready || !outOfBase.ready ? "…" : brl(x));
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4" data-testid="dashboard-benefits">
      <StatCard icon={Fuel} label="Combustível (quinzena)" value={v(t.fuel)} accent="orange" testId="stat-ben-fuel" />
      <StatCard icon={Utensils} label="Vale Refeição (quinzena)" value={v(t.meal)} accent="emerald" testId="stat-ben-meal" />
      <StatCard icon={Bus} label="Deslocamento (quinzena)" value={v(t.commute)} accent="sky" testId="stat-ben-commute" />
      <StatCard icon={Trophy} label="Produtividade (quinzena)" value={reports.loading || tiersData.loading ? "…" : brl(t.prod)} accent="rose" testId="stat-ben-prod" />
    </div>
  );
};
